import { render, staticRenderFns } from "./UploadAgreement.vue?vue&type=template&id=7226ff3c"
import script from "./UploadAgreement.vue?vue&type=script&lang=js"
export * from "./UploadAgreement.vue?vue&type=script&lang=js"
import style0 from "./UploadAgreement.vue?vue&type=style&index=0&id=7226ff3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports